import { Avatar, Box, Chip, LinearProgress, Tooltip, Typography } from "@mui/joy";
import { Button, IconButton } from "../../../../shared";
import { ChevronRight, FileDown, MessageCircle } from "lucide-react";

export function TitleGFC(props: any) {
    const { Name, Description, Id } = props.data;
    return (
        <Box py={1.5}>
            <Typography level="title-md" sx={{ fontWeight: 400 }}>
                {Name}
            </Typography>
            <Typography level="body-md" sx={{ opacity: 0.7 }}>
                {Description}
            </Typography>
        </Box>
    );
}

export function TaskSummaryGFC({ data }: any) {
    const { TaskSummary } = data;
    const completed = TaskSummary?.COMPLETED || 0;
    const total = TaskSummary?.TotalTasks || 1;
    const percent = Math.round((completed / total) * 100);

    return (
        <Box width={"100%"}>
            <Typography typography="body-md" color="warning" gutterBottom>
                {completed} completed out of {total}, {percent}%
            </Typography>
            <LinearProgress
                variant="soft"
                sx={{ border: "1px solid", borderColor: "divider" }}
                determinate
                value={percent}
                color={percent > 50 ? "success" : "danger"}
            />
        </Box>
    );
}

export function SalesNdStatusGFC({ data }: any) {
    const { Status, SalesmanName } = data;
    return (
        <Box display="flex" alignItems="center" gap={1}>
            <Chip
                color={Status === "CANCELLED" ? "danger" : Status === "IN-PROGRESS" ? "success" : "warning"}
                sx={{
                    borderRadius: "6px",
                    border: "1px solid",
                    borderColor: "divider",
                    minWidth: 120,
                    fontSize: 12,
                    fontWeight: "lg",
                    textAlign: "center",
                }}
            >
                {Status}
            </Chip>
            <Box sx={{ width: "100%" }}>
                <Tooltip title={SalesmanName} arrow>
                    <Avatar size="sm" alt={SalesmanName} sx={{ border: "1px solid", borderColor: "divider" }}>
                        {SalesmanName.charAt(0)}
                    </Avatar>
                </Tooltip>
            </Box>
        </Box>
    );
}

export function CustomerAddressGFC({ data }: any) {
    const { CustomerStreet, CustomerCity, CustomerState = "—", CustomerZipCode, CustomerCountry = "USA" } = data;

    return (
        <Box flex={1}>
            <Typography level="body-sm" sx={{ fontWeight: "md" }}>
                {CustomerStreet}, {CustomerCity}
            </Typography>
            <Typography level="body-sm">
                {CustomerState} {CustomerCountry}, {CustomerZipCode}
            </Typography>
        </Box>
    );
}

export function ActionButtonsGFC() {
    return (
        <Box display="flex" gap={1} pr={1}>
            <Button
                startDecorator={<MessageCircle size={14} />}
                size="sm"
                variant="soft"
                color="neutral"
                sx={{ border: "1px solid", borderColor: "divider" }}
            >
                12
            </Button>
            <IconButton color="neutral">
                <FileDown size={14} />
            </IconButton>
            <IconButton color="neutral">
                <ChevronRight size={14} />
            </IconButton>
        </Box>
    );
}
